import React, { Fragment } from 'react'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepLabel from '@material-ui/core/StepLabel'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import Paper from '@material-ui/core/Paper'
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItem from 'components/Grid/GridItem.jsx'

// general api service
import { handleApprove, handleReject } from '../../services/generalServiceAPI'
import { titleCase, utcTime, ymd } from '../utility/utility'
import { isEmpty } from 'lodash'
import swal from 'sweetalert2'
import appContext from '../../services/context'

const styles = (theme) => ({
  root: {
    width: '100%',
    marginBottom: '8px',
    // height: '250px'
    // borderRight: '1px solid black'
  },
  panelLeft: {
    width: '100%',
  },
  panelRight: {
    width: '100%',
  },
  buttonDetails: {
    marginTop: '3px',
    marginBottom: '2px',
    marginRight: theme.spacing.unit,
    color: '#03a9f4',
  },
  buttonReject: {
    marginTop: '3px',
    marginBottom: '2px',
    marginRight: theme.spacing.unit,
    color: 'tamato',
  },
  buttonApprove: {
    marginTop: '3px',
    marginBottom: '2px',
    marginRight: theme.spacing.unit,
    color: 'green',
  },
  buttonInvite: {
    marginTop: '3px',
    marginBottom: '2px',
    marginRight: theme.spacing.unit,
    color: '#ffab91',
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
  },
  infoDynamic: {
    color: 'peru', //theme.palette.primary.dark,
    fontWeight: 'bold',
  },
  infoStatic: {
    color: theme.palette.primary.light,
    fontStyle: 'bold',
  },
  active: {
    fill: 'orange',
    // text: {
    //   font: 'italic 20px seif',
    //   fill: 'red'
    // }
  },
  completed: {
    fill: 'green',
    stroke: 'yellow',
    strokeWidth: '1',
  },
})

const getApplicationInfo = (classes, application) => {
  const { type, createdOn, creator, expenseType, expenseOrProcurement, payTo, amount, startDate, endDate } = application
  if (isEmpty(creator)) {
    swal.fire('Error', `Missing the applicant's info, there will be error in further processes. `, 'error')
  }
  const details = () => {
    switch (type.id) {
      case 1:
        return (
          <Fragment>
            <span className={classes.infoStatic}> - Scheduling from </span>
            <span className={classes.infoDynamic}>{ymd(startDate)}</span>
            <span className={classes.infoStatic}> to </span>
            <span className={classes.infoDynamic}>{ymd(endDate)}</span>
          </Fragment>
        )
      case 0:
        return (
          <Fragment>
            <span className={classes.infoStatic}> - </span>
            <span className={classes.infoDynamic}>
              {titleCase(expenseType.name)} , {payTo} , ${Number(amount).toMoney()}
            </span>
          </Fragment>
        )
      default:
    }
  }
  return (
    <div className={classes.instructions}>
      {type.id === 0 ? (
        <span className={classes.infoDynamic}>{titleCase(expenseOrProcurement + ' application')} </span>
      ) : (
        <span className={classes.infoDynamic}>{titleCase(type.name)} </span>
      )}
      <span className={classes.infoStatic}> Created On </span>
      <span className={classes.infoDynamic}>{utcTime(createdOn)}</span>
      <span className={classes.infoStatic}> By </span>
      <span className={classes.infoDynamic}>{isEmpty(creator) ? '' : titleCase(creator.name)}</span>
      {/* <span className={classes.infoDynamic}>{titleCase(creator.name)}</span> */}
      {details()}
    </div>
  )
}
class HorizontalNonLinearStepperWithError extends React.Component {
  static contextType = appContext
  render() {
    const { classes, application, loginUserId } = this.props
    // console.log(this.props)
    // const steps = getSteps()
    // const { activeStep } = this.state
    // logger(`signingflow: ${JSON.stringify(application)}`)
    const currentSigner = application.signers[application.activeStep]
    // const nextSigner = application.activeStep < application.signers.length - 1 ? application.signers[application.activeStep + 1] : {}
    return (
      <Paper className={classes.root} elevation={10} ref={(thisElement) => (this.rootElement = thisElement)}>
        <GridContainer>
          {/* Basic info */}
          <GridItem xs={12} md={12}>
            <Fragment>
              {getApplicationInfo(classes, application)}
              <Divider variant='middle' />
            </Fragment>{' '}
          </GridItem>
          {/* stepper */}
          <GridItem xs={12} md={12}>
            <Stepper activeStep={application.activeStep} alternativeLabel>
              {/* was using splice here instead, it will delete the data in the state of dashboard, so argument passing is a shalow copy only */}
              {application.signers.slice(0, application.lastLevelToSign).map((signer, index) => {
                // logger('SigningFlow', `/application/${application.type.short}/${application.id}`)
                const props = {}
                const labelProps = {}
                // if (step.isOptional) {
                //   labelProps.optional = (
                //     <Typography variant="caption" color="error">
                //       Optional step
                //     </Typography>
                //   )
                // }
                if (signer.action === 'reject') {
                  labelProps.error = true
                }
                // if (signer.action === 'approve') {
                //   props.completed = true
                // } else {
                //   props.completed = false
                // }
                // if (step.isSkipped) {
                //   props.completed = false
                // }
                return (
                  <Step key={index} {...props}>
                    <StepLabel
                      {...labelProps}
                      StepIconProps={{
                        classes: {
                          active: classes.active,
                          completed: classes.completed,
                          text: classes.text,
                        },
                      }}
                    >
                      {signer.fullName}
                    </StepLabel>
                  </Step>
                )
              })}
            </Stepper>
          </GridItem>
          {!isEmpty(currentSigner) ? (
            <GridItem xs={12} md={12}>
              <Divider variant='middle' />
              <div style={{ textAlign: 'center ', margin: ' 0px, 2px' }}>
                {/* whoever seeing this application have access to it already, so give them capability to show detail and add invites  */}
                <Button
                  // disabled={activeStep === 0}
                  variant='outlined'
                  color='secondary'
                  onClick={() => {
                    this.props.history.push(`/application/${application.type.short}/${application.id}`)
                  }}
                  className={classes.buttonDetails}
                >
                  Details
                </Button>
                {/* only when the current user is the current signer, populate approve/reject */}
                {/* {jsonPP({ id: currentSigner.id, loginUserId })} */}
                {currentSigner.id === loginUserId ? (
                  <Fragment>
                    <Button
                      // disabled={activeStep === 0}
                      variant='outlined'
                      color='secondary'
                      onClick={() => {
                        if (isEmpty(currentSigner.email)) {
                          swal.fire('Error', `Missing ${currentSigner.fullName}'s email, can not reject this application successfully. `, 'error', {
                            timer: 1500,
                          })
                        } else {
                          handleReject({ application, refresh: this.props.refresh, pullingNumbers: this.context.pullingNumbers })
                        }
                      }}
                      className={classes.buttonReject}
                    >
                      Reject
                    </Button>
                    <Button
                      variant='outlined'
                      color='primary'
                      onClick={() => {
                        if (isEmpty(currentSigner.email)) {
                          // logger('SigningFlow', currentSigner)
                          swal.fire('Error', `Missing ${currentSigner.fullName}'s email, can not approve this application successfully. `, 'error', {
                            timer: 1500,
                          })
                        } else {
                          handleApprove({ application, refresh: this.props.refresh, pullingNumbers: this.context.pullingNumbers })
                        }
                      }}
                      className={classes.buttonApprove}
                    >
                      Approve
                    </Button>
                  </Fragment>
                ) : (
                  ''
                )}
              </div>
            </GridItem>
          ) : (
            <Fragment />
          )}
        </GridContainer>
      </Paper>
    )
  }
}

HorizontalNonLinearStepperWithError.propTypes = {
  classes: PropTypes.object,
}

export default withRouter(withStyles(styles)(HorizontalNonLinearStepperWithError))

//<StepContent>{step.position}</StepContent>
